export enum SubscriberType {
    None = null,
    Child = 1, 
    Parent = 2, 
    Spouse = 3,
    CommonLawSpouse = 4,
    Other = 5,
    InjuredParty = 6,
    Self = 7
}